import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowUp, ArrowDown, ArrowRight, Check } from "lucide-react";

const DIR = {
  up: { Icon: ArrowUp, color: "#5F8213" },
  down: { Icon: ArrowDown, color: "#D95C5C" },
  flat: { Icon: ArrowRight, color: "#9A9C90" },
  check: { Icon: Check, color: "#5F8213" },
};

export default function SignalTicker({ items = [], count }) {
  const navigate = useNavigate();
  const row = [...items, ...items];
  return (
    <div className="card overflow-hidden" data-testid="signal-ticker">
      <div className="flex items-center gap-4 px-5 py-3">
        <div className="shrink-0 flex items-center gap-2">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-60" style={{ background: "#93C020" }} />
            <span className="relative inline-flex rounded-full h-2 w-2" style={{ background: "#93C020" }} />
          </span>
          <span className="label-caps whitespace-nowrap">What's powering your score</span>
        </div>
        <div className="flex-1 overflow-hidden ticker-mask">
          <div className="ticker-track flex items-center gap-6 whitespace-nowrap">
            {row.map((it, i) => {
              const { Icon, color } = DIR[it.dir] || DIR.flat;
              return (
                <button key={i} onClick={() => navigate("/app/growth-score")}
                  className="inline-flex items-center gap-1.5 text-sm text-ink-2 hover:text-ink transition-colors" data-testid={`ticker-item-${i}`}>
                  <span>{it.label}</span>
                  <Icon size={13} strokeWidth={2.5} style={{ color }} />
                </button>
              );
            })}
          </div>
        </div>
        <button onClick={() => navigate("/app/growth-score")} className="shrink-0 text-xs font-semibold inline-flex items-center gap-1 hover:gap-1.5 transition-all" style={{ color: "#5F8213" }} data-testid="see-all-factors">
          See all {count} factors <ArrowRight size={13} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
}
